import React from 'react'
import { Container, Row, Col, Button, Spinner, Badge, FormLabel , Form } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import moment from 'moment';

export function TicketFiltersBar({ 
    showResults,
    data, 
    isLoading, 
    fromDateFilters, 
    setFromDateFilters, 
    toDateFilters, 
    setToDateFilters, 
    statusFilters, 
    setStatusFilters 
}) {
  return (
    <Container>
        <Row className="mb-3 d-flex align-items-center justify-content-end" >
            <Col className='d-flex justify-content-end align-items-center' style={{ flex: 'fit-content 0' , marginLeft: '1rem' }}> 
                {
                    isLoading ?
                        <Spinner animation="border" role="status" />
                        :
                        showResults && <p className='text-muted small m-0'>{data?.body?.length} Segnalazioni Trovate</p>
                }
            </Col>
            <Col className='d-flex justify-content-end align-items-center'  style={{ flex: 'fit-content 0' , marginLeft: '1rem' , marginRight: '0rem' }}>
                <FormLabel className='small m-0 me-2' >Aperte dal</FormLabel>
                <Form.Control type="date" style={{ width: 'fit-content' }} value={fromDateFilters} onChange={(e) => setFromDateFilters(e.target.value)} />
            </Col>
            <Col className='d-flex justify-content-end align-items-center'  style={{ flex: 'fit-content 0' , marginLeft: '0rem' }}>
                <FormLabel className='small m-0 me-2'>al</FormLabel>
                <Form.Control type="date" style={{ width: 'fit-content' }} value={toDateFilters} onChange={(e) => setToDateFilters(e.target.value)} />
            </Col>
            <Col className='d-flex justify-content-end align-items-center'  style={{ flex: 'fit-content 0' , marginLeft: '1rem' }}>
                <Form.Select aria-label="Filtro per stato della segnalazione" defaultValue={statusFilters} onChange={(e) => setStatusFilters(e.target.value)}>
                    <option value={'all'} >Tutte le segnalazioni</option>
                    <option value={'5_OPEN'} >Solo aperte</option>
                    <option value={'10_IN_PROGRESS'} >Solo in gestione</option>
                    <option value={'15_CLOSED'} >Solo chiuse</option>
                </Form.Select>
            </Col>
        </Row>
    </Container>
  )
}

export async function fetchTicket({ queryFilters }) {

    
    // Initialize convertedFilters as an object
    const convertedFilters = {};

    if (queryFilters.status && queryFilters.status !== 'all' && queryFilters.status !== '') {
      convertedFilters['status'] = {
        type: 'value',
        value: queryFilters.status,
      };
    }

    if (queryFilters.fromDate && queryFilters.fromDate !== '' || queryFilters.toDate && queryFilters.toDate !== '') {

      let fromDate = moment(queryFilters.fromDate);
      let toDate = moment(queryFilters.toDate);
      const isDateOrdered = fromDate.isBefore(toDate);
  
      if(!isDateOrdered) {
          const tempDate = fromDate;
          fromDate = toDate;
          toDate = tempDate;
      }

      toDate = toDate.add(1, 'days');

      const timestampmin = fromDate.startOf('day').unix();
      const timestampmax = toDate.endOf('day').unix();

      if (queryFilters.fromDate && queryFilters.toDate && queryFilters.fromDate !== '' && queryFilters.toDate !== '') {
          convertedFilters['date'] = {
              type: 'range',
              min: fromDate.format('YYYY-MM-DD'),
              max: toDate.format('YYYY-MM-DD'),
              range_type: 'date'
          };
      }
    }

    console.log('convertedFilters', convertedFilters);

    const response = await DataManager.searchItems('ticket', 1, 9999999, { 'field': 'id', 'order': 'ASC' }, '' , [] , convertedFilters);
    console.log('response', response.total);
    return response || [];
  }